import{Box}from'pcln-design-system';import React from'react';var Gpt=function Gpt(props){return/*#__PURE__*/React.createElement(Box,null,props.render());};Gpt.displayName='Gpt';export default Gpt;
//# sourceMappingURL=Gpt.js.map